"use strict";

exports.__esModule = true;

var theme_1 = require("../theme");
/**
 * Object root
 */


exports.Root = theme_1["default"]('div')({
  display: 'inline-block',
  wordBreak: 'break-all',
  '&::after': {
    content: "' '",
    display: 'inline-block'
  },
  '& > li': {
    backgroundColor: 'transparent !important',
    display: 'inline-block'
  },
  '& ol:empty': {
    paddingLeft: '0 !important'
  }
});
/**
 * Table
 */

exports.Table = theme_1["default"]('span')({
  '& > li': {
    display: 'inline-block',
    marginTop: 5
  }
});
/**
 * HTML
 */

exports.HTML = theme_1["default"]('span')({
  display: 'inline-block',
  '& div:hover': {
    backgroundColor: 'rgba(255, 220, 158, .05) !important',
    borderRadius: '2px'
  }
});
/**
 * Object constructor
 */

exports.Constructor = theme_1["default"]('span')({
  '& > span > span:nth-child(1)': {
    opacity: 0.6
  }
});